// recoil module
import { useSetRecoilState } from "recoil";

// import  auth fron store
import { authAtom } from "../shared/auth";

// login api service
import { login } from "../services/auth";

// success message from utils
import { successMessage } from "../utils/message";
import { setHeaderAPI } from "../services/apiConfig";

// useAuth action for create login method
export const useAuthActions = () => {
  // setAuth because we needed
  const setAuth = useSetRecoilState(authAtom);

  // user loadin function send data to api and gettin response
  const userLogin = async (navigate, userData, recaptchaToken) => {
    // if (recaptchaToken) {
    const { data } = await login(userData);

    //save data in localStorage
    localStorage.setItem("profile", JSON.stringify(data));

    setAuth(data);
    // success message
    successMessage("شما با موفقیت وارد شدید");
    setHeaderAPI();
    // window.location.reload();
    // navigate to blog page if login successfully done!
    navigate("/dashboard", { replace: true });
  };
  // };

  return {
    userLogin,
  };
};
